// extracted by mini-css-extract-plugin
export default {"root":"_1DVkm","shadow":"_1oMB6"};